import { fetchApi } from '@/config/axiosSetting';
import {
  WalletYearlyReportMutationParamsType,
  WalletYearlyReportQueryResponseType,
} from './walletYearlyReportMutation.type';

export const walletYearlyReportFunction = (
  params: WalletYearlyReportMutationParamsType,
): Promise<WalletYearlyReportQueryResponseType> => {
  return fetchApi.post('financial/report/', { ...params });
};
